



























import { Component, Vue } from "vue-property-decorator";
import { opportunityStore } from "@/store/modules/OpportunityStore";

@Component
export default class extends Vue {
   get totalLifePolicies(): number {
    return opportunityStore.totalLifePolicies;
  }
  get totalAnnuityPolicies(): number {
    return opportunityStore.totalAnnuityPolicies;
  }
  get totalCount():number{
    return opportunityStore.totalCount;
  }
}
